export function cleanHebrewToken(value = '') {
  return (value || '').replace(/["'׳״]/g, '').trim();
}

export function normalizeUserMonth(month = '') {
  return cleanHebrewToken(month).replace('חשוון', 'חשון').replace('סיוון', 'סיון');
}

export function normalizeApiName(name = '') {
  return (name || '').replace(/\s[0-9]+/g, '');
}

export function parseHebrewDateDisplay(hebrew = '') {
  return cleanHebrewToken(hebrew)
    .split(/\s+/)
    .filter(Boolean);
}
